(function(){

const sizeMap = {

  "Single": "91 × 190 cm",
  "King Single": "107 × 203 cm",
  "Double": "137 × 190 cm",
  "Queen": "153 × 203 cm",
  "King": "183 × 203 cm"

};


function addSizeDimensions(){


document.querySelectorAll(
'.option-selector label.opt-label'
).forEach(label=>{


if(label.querySelector('.size-dimension-text')){
return;
}


const text =
label.childNodes[0]?.textContent?.trim();


if(!sizeMap[text]){
return;
}


const span=document.createElement('span');

span.className='size-dimension-text';

span.textContent=sizeMap[text];


label.appendChild(span);


});


}



// 首次执行

addSizeDimensions();



// Shopify重新渲染监听

const observer = new MutationObserver(()=>{

addSizeDimensions();

});


observer.observe(
document.body,
{
childList:true,
subtree:true
}
);



})();